// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { Badge } from "@/components/ui/badge";

const IMPORT_TYPE_COLORS: Record<string, string> = {
  boh: "bg-blue-100 text-blue-700 border-blue-200 dark:bg-blue-950 dark:text-blue-300 dark:border-blue-900",
  metadata:
    "bg-purple-100 text-purple-700 border-purple-200 dark:bg-purple-950 dark:text-purple-300 dark:border-purple-900",
  sales: "bg-green-100 text-green-700 border-green-200 dark:bg-green-950 dark:text-green-300 dark:border-green-900",
  pricing: "bg-amber-100 text-amber-700 border-amber-200 dark:bg-amber-950 dark:text-amber-300 dark:border-amber-900",
  planogram: "bg-pink-100 text-pink-700 border-pink-200 dark:bg-pink-950 dark:text-pink-300 dark:border-pink-900",
};

const FALLBACK_COLORS = [
  "bg-cyan-100 text-cyan-700 border-cyan-200 dark:bg-cyan-950 dark:text-cyan-300 dark:border-cyan-900",
  "bg-rose-100 text-rose-700 border-rose-200 dark:bg-rose-950 dark:text-rose-300 dark:border-rose-900",
  "bg-lime-100 text-lime-700 border-lime-200 dark:bg-lime-950 dark:text-lime-300 dark:border-lime-900",
  "bg-violet-100 text-violet-700 border-violet-200 dark:bg-violet-950 dark:text-violet-300 dark:border-violet-900",
  "bg-sky-100 text-sky-700 border-sky-200 dark:bg-sky-950 dark:text-sky-300 dark:border-sky-900",
] as const;

function normalizeType(type: string): string {
  const lower = type.toLowerCase();
  if (lower === "boh-partial" || lower === "boh_partial") return "boh";
  return lower;
}

function hashString(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
}

function getColorClass(type: string): string {
  const normalized = normalizeType(type);
  const mapped = IMPORT_TYPE_COLORS[normalized];
  if (mapped) return mapped;
  return FALLBACK_COLORS[hashString(normalized) % FALLBACK_COLORS.length] ?? FALLBACK_COLORS[0];
}

export function ImportTypeBadge({ type }: { type: string }) {
  return (
    <Badge variant="outline" className={`font-normal text-xs ${getColorClass(type)}`}>
      {type}
    </Badge>
  );
}
